import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'
import NewMain from '../headerone/newMain'
function IQACCertificate() {
  return (
    <>
      <NewMain />
      <Bredcom title="Home" subtitle="Certificate" />
      <div class="container my-5">
        <div className='IQACCertificate_table'>
          <h4> National Faculty Development Program</h4>
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Certificate number</th>
                </tr>
              </thead>
              <tbody>
                  <tr>
   <td>DR.R.MANIVANNAN</td>
   <td>MVNU/IQAC/2025/NFDP-01</td>
</tr>
<tr>
   <td>ROHIT SAHU</td>
   <td>MVNU/IQAC/2025/NFDP-02</td>
</tr>
<tr>
   <td>DR. MUKESH KUMAR SINGH</td>
   <td>MVNU/IQAC/2025/NFDP-03</td>
</tr>
<tr>
   <td>DR. SONIA SHARMA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-04</td>
</tr>
<tr>
   <td>AMIT KUMAR<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-05</td>
</tr>
<tr>
   <td>SUNIL KUMAR TIWARI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-06</td>
</tr>
<tr>
   <td>ANURAG CHOURASIA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-07</td>
</tr>
<tr>
   <td>KOMAL SONI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-08</td>
</tr>
<tr>
   <td>LAXMI KANT<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-09</td>
</tr>
<tr>
   <td>ASTHA GUPTA</td>
   <td>MVNU/IQAC/2025/NFDP-10</td>
</tr>
<tr>
   <td>PARVEEN SHARMA</td>
   <td>MVNU/IQAC/2025/NFDP-11</td>
</tr>
<tr>
   <td>PRIYANKA SINGH</td>
   <td>MVNU/IQAC/2025/NFDP-12</td>
</tr>
<tr>
   <td>DR. ALKA SINGH</td>
   <td>MVNU/IQAC/2025/NFDP-13</td>
</tr>
<tr>
   <td>DR. HARENDER DAGAR</td>
   <td>MVNU/IQAC/2025/NFDP-14</td>
</tr>
<tr>
   <td>DISHA SHARMA</td>
   <td>MVNU/IQAC/2025/NFDP-15</td>
</tr>
<tr>
   <td>VIDHAN CHAND BALA</td>
   <td>MVNU/IQAC/2025/NFDP-16</td>
</tr>
<tr>
   <td>DR. PRASHANT KUMAR<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-17</td>
</tr>
<tr>
   <td>DR. RAJNISH KUMAR<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-18</td>
</tr>
<tr>
   <td>DR. RAMVEER SINGH</td>
   <td>MVNU/IQAC/2025/NFDP-19</td>
</tr>
<tr>
   <td>AISHWARYA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-20</td>
</tr>
<tr>
   <td>ANANT PANDEY<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-21</td>
</tr>
<tr>
   <td>DR. GARIMA VERMA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-22</td>
</tr>
<tr>
   <td>NASIB SINGH</td>
   <td>MVNU/IQAC/2025/NFDP-23</td>
</tr>
<tr>
   <td>DR KISHAN SINGH PT</td>
   <td>MVNU/IQAC/2025/NFDP-24</td>
</tr>
<tr>
   <td>DR. SHARKI (PT)</td>
   <td>MVNU/IQAC/2025/NFDP-25</td>
</tr>
<tr>
   <td>DR. DIVYA SINGH PT<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-26</td>
</tr>
<tr>
   <td>DAYA SHANKAR PRASAD<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-27</td>
</tr>
<tr>
   <td>DR. SWATI CHITRANSHI</td>
   <td>MVNU/IQAC/2025/NFDP-28</td>
</tr>
<tr>
   <td>DR BHAWANA JOSHI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-29</td>
</tr>
<tr>
   <td>PRADNYA NARESH CHAUDHARI</td>
   <td>MVNU/IQAC/2025/NFDP-30</td>
</tr>
<tr>
   <td>SHILPA NAMDEO TAMBE<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-31</td>
</tr>
<tr>
   <td>MR JOECECIL R<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-32</td>
</tr>
<tr>
   <td>VIVEK KUMAR<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-33</td>
</tr>
<tr>
   <td>VISHWANATH KULLOLI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-34</td>
</tr>
<tr>
   <td>DR. SHAILLY ANAND</td>
   <td>MVNU/IQAC/2025/NFDP-35</td>
</tr>
<tr>
   <td>PROF. ATUL KAUSHIK</td>
   <td>MVNU/IQAC/2025/NFDP-36</td>
</tr>
<tr>
   <td>ABHISHEK K</td>
   <td>MVNU/IQAC/2025/NFDP-37</td>
</tr>
<tr>
   <td>AMREEN QURESHI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-38</td>
</tr>
<tr>
   <td>SUDHIR KAUSHIK</td>
   <td>MVNU/IQAC/2025/NFDP-39</td>
</tr>
<tr>
   <td>MANOJ SHARMA</td>
   <td>MVNU/IQAC/2025/NFDP-40</td>
</tr>
<tr>
   <td>MS. DIPTI TIWARI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-41</td>
</tr>
<tr>
   <td>NEHA DAGAR</td>
   <td>MVNU/IQAC/2025/NFDP-42</td>
</tr>
<tr>
   <td>NEHA BHAMBOO</td>
   <td>MVNU/IQAC/2025/NFDP-43</td>
</tr>
<tr>
   <td>MANSI GABA</td>
   <td>MVNU/IQAC/2025/NFDP-44</td>
</tr>
<tr>
   <td>YOGESH VASHISTH</td>
   <td>MVNU/IQAC/2025/NFDP-45</td>
</tr>
<tr>
   <td>MR. SUSHOVAN ROY<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-46</td>
</tr>
<tr>
   <td>MANISH KUMAR CHITRANSHI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-47</td>
</tr>
<tr>
   <td>DR HARDITA DHAMELIA</td>
   <td>MVNU/IQAC/2025/NFDP-48</td>
</tr>
<tr>
   <td>ABHISHEK KUMAR<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-49</td>
</tr>
<tr>
   <td>SHREYASI</td>
   <td>MVNU/IQAC/2025/NFDP-50</td>
</tr>
<tr>
   <td>PRINCE RAJ</td>
   <td>MVNU/IQAC/2025/NFDP-51</td>
</tr>
<tr>
   <td>DR. SAKSHI GARG (PT)</td>
   <td>MVNU/IQAC/2025/NFDP-52</td>
</tr>
<tr>
   <td>RAMVEER SINGH<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-53</td>
</tr>
<tr>
   <td>CHAYA RANI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-54</td>
</tr>
<tr>
   <td>MS RAMANDEEP KAUR<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-55</td>
</tr>
<tr>
   <td>SHIVALI RAHI</td>
   <td>MVNU/IQAC/2025/NFDP-56</td>
</tr>
<tr>
   <td>ABHINAV MEHTA</td>
   <td>MVNU/IQAC/2025/NFDP-57</td>
</tr>
<tr>
   <td>PRIYA</td>
   <td>MVNU/IQAC/2025/NFDP-58</td>
</tr>
<tr>
   <td>KAJAL GULATI</td>
   <td>MVNU/IQAC/2025/NFDP-59</td>
</tr>
<tr>
   <td>HEMLATA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-60</td>
</tr>
<tr>
   <td>LALIT SHARMA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-61</td>
</tr>
<tr>
   <td>ANUJ KUMAR MISHRA</td>
   <td>MVNU/IQAC/2025/NFDP-62</td>
</tr>
<tr>
   <td>VAIBHAV SINGH<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-63</td>
</tr>
<tr>
   <td>S GOPIKA</td>
   <td>MVNU/IQAC/2025/NFDP-64</td>
</tr>
<tr>
   <td>DR PRIYA GARG (PT)</td>
   <td>MVNU/IQAC/2025/NFDP-65</td>
</tr>
<tr>
   <td>DR. AMIT SAGU</td>
   <td>MVNU/IQAC/2025/NFDP-66</td>
</tr>
<tr>
   <td>PRASHANT KUMAR SINGH<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-67</td>
</tr>
<tr>
   <td>MR. VIVEK KUMAR SETH</td>
   <td>MVNU/IQAC/2025/NFDP-68</td>
</tr>
<tr>
   <td>SUMAN RANI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-69</td>
</tr>
<tr>
   <td>AASHISH BHARADWAJ</td>
   <td>MVNU/IQAC/2025/NFDP-70</td>
</tr>
<tr>
   <td>NEERAJ BHARDWAJ<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-71</td>
</tr>
<tr>
   <td>SHEETAL BHOLLA</td>
   <td>MVNU/IQAC/2025/NFDP-72</td>
</tr>
<tr>
   <td>DEEPAM GOYAL</td>
   <td>MVNU/IQAC/2025/NFDP-73</td>
</tr>
<tr>
   <td>DR. RITA YADAV<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-74</td>
</tr>
<tr>
   <td>MR. RAHUL</td>
   <td>MVNU/IQAC/2025/NFDP-75</td>
</tr>
<tr>
   <td>ARENDRA PRATAP SINGH</td>
   <td>MVNU/IQAC/2025/NFDP-76</td>
</tr>
<tr>
   <td>DR. MUDITA</td>
   <td>MVNU/IQAC/2025/NFDP-77</td>
</tr>
<tr>
   <td>SHIV KUMAR CHOUHAN<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-78</td>
</tr>
<tr>
   <td>SONIKA PRAJAPATI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-79</td>
</tr>
<tr>
   <td>HEMANT DIWAN</td>
   <td>MVNU/IQAC/2025/NFDP-80</td>
</tr>
<tr>
   <td>DR. MONICA DUTTA</td>
   <td>MVNU/IQAC/2025/NFDP-81</td>
</tr>
<tr>
   <td>RAJKIRAN</td>
   <td>MVNU/IQAC/2025/NFDP-82</td>
</tr>
<tr>
   <td>SONIA GOOMBER</td>
   <td>MVNU/IQAC/2025/NFDP-83</td>
</tr>
<tr>
   <td>ARUN UPMANYU</td>
   <td>MVNU/IQAC/2025/NFDP-84</td>
</tr>
<tr>
   <td>DR. DEEPALI GUPTA</td>
   <td>MVNU/IQAC/2025/NFDP-85</td>
</tr>
<tr>
   <td>DR.JAYAMANTI PANDIT<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-86</td>
</tr>
<tr>
   <td>MUTHURAM G<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-87</td>
</tr>
<tr>
   <td>HIMANI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-88</td>
</tr>
<tr>
   <td>JATIN KISHORE SHARMA</td>
   <td>MVNU/IQAC/2025/NFDP-89</td>
</tr>
<tr>
   <td>DR.SWAPNA S</td>
   <td>MVNU/IQAC/2025/NFDP-90</td>
</tr>
<tr>
   <td>DISHA DESHMUKH<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-91</td>
</tr>
<tr>
   <td>DR.RITAMBHARA KUMARI UPADHYAY<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-92</td>
</tr>
<tr>
   <td>RAVIKIRAN MAHESH SURYAWANSHI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-93</td>
</tr>
<tr>
   <td>RITIKA JAGGI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-94</td>
</tr>
<tr>
   <td>DR.MAHESH KUMAR SHARMA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-95</td>
</tr>
<tr>
   <td>AJIT KUMAR VARMA</td>
   <td>MVNU/IQAC/2025/NFDP-96</td>
</tr>
<tr>
   <td>SUNIL KUMAR PANDEY</td>
   <td>MVNU/IQAC/2025/NFDP-97</td>
</tr>
<tr>
   <td>DR. ALANKAR SHRIVASTAV</td>
   <td>MVNU/IQAC/2025/NFDP-98</td>
</tr>
<tr>
   <td>DR. NARESH KALRA</td>
   <td>MVNU/IQAC/2025/NFDP-99</td>
</tr>
<tr>
   <td>ASHWANI KUMAR SANGHI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-100</td>
</tr>
<tr>
   <td>MS AASHISH YADAV</td>
   <td>MVNU/IQAC/2025/NFDP-101</td>
</tr>
<tr>
   <td>YASHVANI KUMAR<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-102</td>
</tr>
<tr>
   <td>PRIYA KUMARI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-103</td>
</tr>
<tr>
   <td>MANOJ SHARMA</td>
   <td>MVNU/IQAC/2025/NFDP-104</td>
</tr>
<tr>
   <td>DARSHAN PAYLA</td>
   <td>MVNU/IQAC/2025/NFDP-105</td>
</tr>
<tr>
   <td>DR. SURBHI PRADHAN<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-106</td>
</tr>
<tr>
   <td>DR. NIRANJAN SINGH RATHEE<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-107</td>
</tr>
<tr>
   <td>DR. POONAM<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-108</td>
</tr>
<tr>
   <td>ALKA</td>
   <td>MVNU/IQAC/2025/NFDP-109</td>
</tr>
<tr>
   <td>ASHWANI JANGRA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-110</td>
</tr>
<tr>
   <td>DR. RITU</td>
   <td>MVNU/IQAC/2025/NFDP-111</td>
</tr>
<tr>
   <td>DR. HIMANSHU KATARIA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-112</td>
</tr>
<tr>
   <td>DR. ANIL</td>
   <td>MVNU/IQAC/2025/NFDP-113</td>
</tr>
<tr>
   <td>DEEPIKA AHUJA</td>
   <td>MVNU/IQAC/2025/NFDP-114</td>
</tr>
<tr>
   <td>DR. CHANCHAL GARG</td>
   <td>MVNU/IQAC/2025/NFDP-115</td>
</tr>
<tr>
   <td>DR.VANDANA TEWARI</td>
   <td>MVNU/IQAC/2025/NFDP-116</td>
</tr>
<tr>
   <td>DR SAVITA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-117</td>
</tr>
<tr>
   <td>SANTOSH KUMAR SINGH</td>
   <td>MVNU/IQAC/2025/NFDP-118</td>
</tr>
<tr>
   <td>DR. PUSHPA RANI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-119</td>
</tr>
<tr>
   <td>ARTI</td>
   <td>MVNU/IQAC/2025/NFDP-120</td>
</tr>
<tr>
   <td>DR. DHARMENDRA KUMAR JANGHEL</td>
   <td>MVNU/IQAC/2025/NFDP-121</td>
</tr>
<tr>
   <td>DR. RAHUL</td>
   <td>MVNU/IQAC/2025/NFDP-122</td>
</tr>
<tr>
   <td>SAURAV</td>
   <td>MVNU/IQAC/2025/NFDP-123</td>
</tr>
<tr>
   <td>SONU THAKUR<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-124</td>
</tr>
<tr>
   <td>ABHISHEK BHATT</td>
   <td>MVNU/IQAC/2025/NFDP-125</td>
</tr>
<tr>
   <td>ROUNAK CHAHAL</td>
   <td>MVNU/IQAC/2025/NFDP-126</td>
</tr>
<tr>
   <td>SAKSHI</td>
   <td>MVNU/IQAC/2025/NFDP-127</td>
</tr>
<tr>
   <td>DR. ANAMIKA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-128</td>
</tr>
<tr>
   <td>SUMIT TEWATIA</td>
   <td>MVNU/IQAC/2025/NFDP-129</td>
</tr>
<tr>
   <td>ANJALI ADHIKARI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-130</td>
</tr>
<tr>
   <td>AJEET KUMAR MISHRA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-131</td>
</tr>
<tr>
   <td>RIMJHIM ARORA</td>
   <td>MVNU/IQAC/2025/NFDP-132</td>
</tr>
<tr>
   <td>PROF.(DR.) SANTOSH KUMAR SINGH<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-133</td>
</tr>
<tr>
   <td>VISHAL SINGH<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-134</td>
</tr>
<tr>
   <td>DR.LALITA DALAL (PT)</td>
   <td>MVNU/IQAC/2025/NFDP-135</td>
</tr>
<tr>
   <td>ROHIT MALIK</td>
   <td>MVNU/IQAC/2025/NFDP-136</td>
</tr>
<tr>
   <td>MS.NEETU MANDAL</td>
   <td>MVNU/IQAC/2025/NFDP-137</td>
</tr>
<tr>
   <td>AAKASH LUNIYA</td>
   <td>MVNU/IQAC/2025/NFDP-138</td>
</tr>
<tr>
   <td>DR LN PATIDAR</td>
   <td>MVNU/IQAC/2025/NFDP-139</td>
</tr>
<tr>
   <td>DR. TANYA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-140</td>
</tr>
<tr>
   <td>SAPNA CHAUDHAR<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-141</td>
</tr>
<tr>
   <td>DR. DEBABRATA LAHIRY</td>
   <td>MVNU/IQAC/2025/NFDP-142</td>
</tr>
<tr>
   <td>RASHMI SINGH</td>
   <td>MVNU/IQAC/2025/NFDP-143</td>
</tr>
<tr>
   <td>DR SRADHANJALI MOHAPATRA</td>
   <td>MVNU/IQAC/2025/NFDP-144</td>
</tr>
<tr>
   <td>MR. VAIBHAV YADAV<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-145</td>
</tr>
<tr>
   <td>SHWETA SIWAS<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-146</td>
</tr>
<tr>
   <td>RAVI SHANKAR<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-147</td>
</tr>
<tr>
   <td>DR LOKESH KAUSHIK</td>
   <td>MVNU/IQAC/2025/NFDP-148</td>
</tr>
<tr>
   <td>YOGESH KUMAR KAUSHIK<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-149</td>
</tr>
<tr>
   <td>GEETA MAHLAWAT</td>
   <td>MVNU/IQAC/2025/NFDP-150</td>
</tr>
<tr>
   <td>AFSANA</td>
   <td>MVNU/IQAC/2025/NFDP-151</td>
</tr>
<tr>
   <td>DIMPI JAISWAL<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-152</td>
</tr>
<tr>
   <td>DR. SARASWATI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-153</td>
</tr>
<tr>
   <td>VIKRAM MANCHANDA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-154</td>
</tr>
<tr>
   <td>ARADHANA SOROUT</td>
   <td>MVNU/IQAC/2025/NFDP-155</td>
</tr>
<tr>
   <td>PARVEEN CHAUHAN<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-156</td>
</tr>
<tr>
   <td>DR. DEEPA DEVI VERMA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-157</td>
</tr>
<tr>
   <td>SUPRIYA VAISH</td>
   <td>MVNU/IQAC/2025/NFDP-158</td>
</tr>
<tr>
   <td>RINKI SINGH</td>
   <td>MVNU/IQAC/2025/NFDP-159</td>
</tr>
<tr>
   <td>ASHISH KUSHWAHA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-160</td>
</tr>
<tr>
   <td>PREETI HANDA KAKKAR<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-161</td>
</tr>
<tr>
   <td>DR. RANI MANSURI</td>
   <td>MVNU/IQAC/2025/NFDP-162</td>
</tr>
<tr>
   <td>DR. DEEPANSHU RANA</td>
   <td>MVNU/IQAC/2025/NFDP-163</td>
</tr>
<tr>
   <td>RITU DAHIYA</td>
   <td>MVNU/IQAC/2025/NFDP-164</td>
</tr>
<tr>
   <td>DR. KHUSHBOO SHARMA</td>
   <td>MVNU/IQAC/2025/NFDP-165</td>
</tr>
<tr>
   <td>NIDHI VASHISHT<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-166</td>
</tr>
<tr>
   <td>DR MANTESH KUMARI YADAV<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-167</td>
</tr>
<tr>
   <td>ANJU TIWARI<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-168</td>
</tr>
<tr>
   <td>DR PRIYA DHIMAN<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-169</td>
</tr>
<tr>
   <td>MANMOHAN SHARMA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-170</td>
</tr>
<tr>
   <td>DR. RUBY MITTAL</td>
   <td>MVNU/IQAC/2025/NFDP-171</td>
</tr>
<tr>
   <td>BHARTI CHAUDHARY<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-172</td>
</tr>
<tr>
   <td>DR.AMISHA VYAS</td>
   <td>MVNU/IQAC/2025/NFDP-173</td>
</tr>
<tr>
   <td>RUPA GUPTA<span> </span></td>
   <td>MVNU/IQAC/2025/NFDP-174</td>
</tr>

                 
              </tbody>
            </table>
          </div>
        </div> 
      </div>
    </>
  )
}

export default IQACCertificate